import React, { Component } from "react";
import ReactAudioPlayer from "react-audio-player";

class AudioWedding extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      alert: null,
    };
  }

  render() {
    return (
      <div>
        <ReactAudioPlayer
          src={this.props.musicurl}
          autoPlay={true}
          muted={this.props.muted}
          loop={true}
        />
      </div>
    );
  }
}

export default AudioWedding;
